import React from 'react';
import PropTypes from 'prop-types';

const Tooltip = ({ percent, isVisible })=> {
  return (
    <div className="tooltip" style={{ opacity: isVisible ? 1 : 0 }}>
      <span className="tooltip__text">Season Avg. </span>
      <span className="tooltip__text" style={{ paddingLeft: "4px" }}>{percent.toFixed(1)}</span>
      <div className="tooltip__triangle"/>
    </div>
  );
};

Tooltip.propTypes = {
  isVisible: PropTypes.bool,
  percent: PropTypes.number
};

Tooltip.defaultProps = {
  isVisible: false,
  percent: 0
};

export default Tooltip;